import ArticleTypesCell from './ArticleTypesCell';

export default ArticleTypesCell;
